import React,{useState} from 'react';
// import Video from '../../videos/video.mp4';
// import { HashLink as Link } from 'react-router-hash-link';
import exterior2 from '../../images/exterior converted/exterior2.jpg';
import{Button} from '../ButtonElement';
import {HeroContainer,
        HeroBg,
        VideoBg,
        HeroContent,
        HeroH1,
        HeroP,
        HeroBtnWrapper,
        ArrowForward,
        ArrowRight,ImageBg,GetLink} from './HeroElements';


const HeroSection = (props)=> {
    const[hover,setHover]= useState(false);

    const onHover = ()=>{
        setHover(!hover); 
    }

    return (
        <HeroContainer id='home'>
            <HeroBg>
               
              
                <ImageBg src={exterior2} />
            </HeroBg>
            <HeroContent>
            

                <HeroH1 className='titre'>
                    Welcome to <span className='hotel-name'>SAI SHREYAS RESIDENCY</span>
                </HeroH1>
                <HeroP>
                Our Motto: Ideal Service to our Guests with Hygienic Conduct and Atmosphere 
                </HeroP>
                <HeroBtnWrapper>
                    <GetLink  style={{textDecoration:'none'}} to="/#explore" onMouseEnter={onHover} onMouseLeave={onHover} >
                        Get started {hover?<ArrowForward style={{verticalAlign:"text-top"}} />:<ArrowRight style={{verticalAlign:"text-top"}} />}
                    </GetLink>
                </HeroBtnWrapper>
            </HeroContent>

           







        </HeroContainer>
    )
}

export default HeroSection
